// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__31jhB","head":"Table_head__3sD1u","col":"Table_col__1-cqm"};